import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch, RootState, AppDispatch } from '../../redux/store'
import { useTranslation } from 'react-i18next'
import { getActionsBySubDomainId } from '../../redux/actions/actionActions'
import { RelatedActionsPanel } from '../../components/common/detail'

interface ActionListBySubDomainProps {
  IdSubDomain: string
  open?: boolean
  onToggle?: () => void
}

const ActionListBySubDomain: React.FC<ActionListBySubDomainProps> = ({
  IdSubDomain,
  open = true,
  onToggle,
}) => {
  const { t } = useTranslation()
  const dispatch: AppDispatch = useAppDispatch()
  const actionsList = useSelector(
    (state: RootState) => state.action.actionsBySubDomains
  )
  const loading = useSelector((state: RootState) => state.action.loading)
  const roles = useSelector((state: RootState) => state.auth.roles)

  useEffect(() => {
    if (IdSubDomain) dispatch(getActionsBySubDomainId(IdSubDomain))
  }, [dispatch, IdSubDomain])

  return (
    <RelatedActionsPanel
      title={t('maturityScoringPage.tasks')}
      listTitle={t('tables.taskTable.title')}
      emptyMessage={t('maturityScoringPage.noTasks', {
        defaultValue: 'No task is linked to this maturity subdomain yet.',
      })}
      rows={Array.isArray(actionsList) ? actionsList : []}
      loading={loading}
      loadingDeps={[IdSubDomain]}
      roles={roles}
      open={open}
      onToggle={onToggle}
    />
  )
}

export default ActionListBySubDomain
